export const data = {
  imgObj: {
    alt: '',
    src: 'https://media.product.which.co.uk/prod/images/original/45911cfc037b-tooliconhigh.jpg',
  },
  title: 'What was your minimum guaranteed line speed in megabits per second (Mbps)?',
  placeholderText: 'e.g. 150',
  standFirst: 'Please check your broadband contract for this information',
}
